// extracted by mini-css-extract-plugin
export var dialog = "a1722c8132955d320aca3d3f587a0616-css";